<template>
  <div>
    <v-alert
      type="error"
      :value="loaded && !isAccountAdmin"
      outlined
      class="mx-3"
    >
      Contact your account administrator for access to the share register.
    </v-alert>
    <share-register v-if="isAccountAdmin && !showNewShareRegister" />
    <new-share-register v-else-if="isAccountAdmin && showNewShareRegister" />
  </div>
</template>

<script>
import ShareRegister from '@/components/ShareRegister.vue'
import NewShareRegister from '@/components/shareRegister/ShareRegister.vue'

export default {
  name: 'ShareRegisterWrapper',
  components: {
    ShareRegister, NewShareRegister
  },
  data: () => ({
    loaded: false
  }),
  computed: {
    showNewShareRegister() {
      return this.globalFeatureToggleSet.newShareRegister
    }

  },
  beforeCreate() {
    this.dispatchActions(['get_globalFeatureToggleSet'])
    this.mapGetters(['isAccountAdmin'])
    this.mapStates(['globalFeatureToggleSet'])
    this.$store.dispatch('get_claims').then(() => {
      this.loaded = true
    })
  }
}
</script>
